module.exports = __webpack_public_path__ + "static/media/userClock.51684375.svg";